import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import LMSNavbarData from "./constants";
import FincoboxFullLogo from "@/assets/fincobox_logo.png";
import FincoboxMinimalLogo from "@/assets/fincobox_favicon.png";
import { AppIcon } from '@/components/Icon';

const Navbar = () => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const location = useLocation();

  const sidebarIcons = {
    dashboard: <AppIcon name="Dashboard" />,
    transactions: <AppIcon name="Transactions" />,
    reports: <AppIcon name="Reports" />,
    loan_information: <AppIcon name="LoanInformation" />,
  };

  return (
    <div
      className={`h-screen bg-white hover:bg-gray-200 border-r border-gray-200 transition-all duration-100 ease-in-out flex flex-col ${isCollapsed ? "w-28" : "w-72"
        }`}
      onMouseEnter={() => setIsCollapsed(false)}
      onMouseLeave={() => setIsCollapsed(true)}
    >
      {/* Logo */}
      <div className="flex items-center justify-center p-4 border-b border-gray-100">
        <img src={isCollapsed ? FincoboxMinimalLogo : FincoboxFullLogo} className="arrCon_btn" style={{ minHeight: "35px", height: "35px", width: isCollapsed ? "50px" : "auto", maxWidth: "100%" }} />
      </div>

      {/* Navigation Links */}
      <ul className="flex-1 m-4 space-y-2 p-0">
        {LMSNavbarData.map((linkItem) => {
          const isActive = location.pathname.includes(linkItem.slug);

          return (
            <li
              key={linkItem.key}
              className={`transition-all duration-300 ${isCollapsed ? "justify-center" : "justify-start"
                } text-gray-700 cursor-pointer rounded-full`}
            >
              <Link to={linkItem.link}>
                <div
                  className={`flex items-center w-full rounded-full text-black transition-all px-4 py-3 hover:bg-yellow-300/30 ${isCollapsed ? "justify-center" : "justify-start gap-4"
                    } ${isActive ? "bg-yellow-300" : ""}`}
                >
                  {/* Icon */}
                  <span className="text-md shrink-0">
                    {sidebarIcons[linkItem.key]}
                  </span>

                  {/* Label */}
                  {!isCollapsed && (
                    <span
                      className={`text-sm font-medium whitespace-nowrap overflow-hidden text-ellipsis transition-all duration-300`}
                    >
                      {linkItem.name}
                    </span>
                  )}
                </div>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Navbar;
